import { h } from 'preact';
import cx from 'classnames';
import style from './style';

export const Row = (props) => {
	let { children } = props;

	// Bail if we have nothing valid to display
	if (!Array.isArray(children) || !children.length) {
		return null;
	}

	return (
		<div class={cx('row', props.class, style.row, props.expand && style.expand)}>
			{children}
		</div>
	);
};

export default Row;
